@if (show) {
  <div [id]="id" class="callout lighter-gray">
    <p id="{{'dialog' + id + 'Desc'}}" class="description" [innerHTML]="advisor + '.' + id + '_text' | translate"></p>
  </div>
}
